import axios from 'axios'
import store from '@/plugins/store'


const mainApiAxios = axios.create({
    baseURL: process.env.VUE_APP_MAIN_API,
    timeout: 500000,
    headers: {
        'Accept': 'application/json; charset=utf-8',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '-1',
    },
})

mainApiAxios.interceptors.request.use(
    (config) => {
        const token = store.getters['user/token']
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    },
)

mainApiAxios.interceptors.response.use(
    (res) => {
        if (res.config.responseType === 'blob') {
            return res
        }

        return res.data

    },
    async (error) => {

        // network errors (CORS / connection reset / aborted) have no `response`
        if (error.response && error.response.status === 401) {
            // `data` is not always an object: the JWT middleware rejects with an empty body, and a
            // failed responseType:'blob' request rejects with a Blob. Reading `.success` straight off
            // it threw a TypeError inside this handler, which replaced the real error and skipped the
            // session cleanup below - the user was left on a dead page instead of being signed out.
            const data = error.response.data
            const success = data && typeof data === 'object' ? data.success : undefined

            if (success === false) {
                // an authenticated user who lacks permission for this resource
                window.location.replace('/PageNotFound')
            } else if (typeof success === 'undefined') {
                // no/expired token - drop the session and go back to the entry point
                store.dispatch('user/removeUserSession')
                if (window.location.pathname != '/login') {
                    window.location.replace('/')
                }
            }
        }
        return Promise.reject(error)
    },
)



export { mainApiAxios }